import { Box, Button } from "@mantine/core";
import { useRef } from "react";

export default function MaintenanceRibbon({
  message,
  onClose,
}: {
  message: string;
  onClose?: () => void;
}) {
  const displayMsgRef = useRef(null);

  const repeatedMessage = Array(10).fill(`⚠️ ${message}`).join("    ");

  return (
    <Box
      style={{
        position: "fixed",    
        top: 0,              
        left: 0,
        zIndex: 9999,          
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "3px 10px",
        backgroundColor: "#FFA500",
        color: "white",
        width: "100%",         
        fontSize: "0.875rem",
        fontWeight: 700,
        height: 50,
        overflow: "hidden",
        whiteSpace: "nowrap",
      }}
      ref={displayMsgRef}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
        }}
      >
        {/* Scrolling marquee */}
        <div
          className="marquee-multi"
          style={{
            flex: "1",
            textAlign: "center",
            marginLeft: 10,
            fontSize: 15,
          }}
        >
          {repeatedMessage}
        </div>

        {/* Close button */}
        <div
          style={{
            flexShrink: 0,
            marginRight: 15,
          }}
        >
          {onClose && (
            <Button
              onClick={onClose}
              style={{
                backgroundColor: "transparent",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
            >
              ✖️
            </Button>
          )}
        </div>
      </div>

      <style>
        {`
          .marquee-multi {
            display: inline-block;
            animation: marquee-right-left 80s linear infinite;
          }

          @keyframes marquee-right-left {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
    </Box>
  );
}
